<div class="slider-container">
  <div class="slider">
    <div class="slides" [style.transform]="getTransform()">
      <div class="slide" *ngFor="let review of reviews">
        <mat-card class="review-card">
          <mat-card-content>
            <p class="review-text">{{ review.text }}</p>
            <p class="client-name">- {{ review.name }}</p>
            <div class="star-rating">
              <ng-container *ngFor="let star of getStarsArray(review.rating)">
                <span class="star">&#9733;</span>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <button class="nav-button prev-button" (click)="prev()">
    &lt;
  </button>
  <button class="nav-button next-button" (click)="next()">
    &gt;
  </button>
</div>
